import { AxiosInstance } from 'axios'
import { SeoMeta } from '@/shared/api/strapi/requests/types'

export type NewsPageBlockDto = {
  news_title: string
  our_press_title: string
  selines_news_title: string
  selines_other_news_title: string
  seo: SeoMeta
}

export type GetNewsPageBlockArgs = {
  locale: string
}

export const getNewsPageBlock = async (client: AxiosInstance, { locale }: GetNewsPageBlockArgs) => {
  const path = `/news-page-block`
  const params = {
    locale,
    fields: ['news_title', 'our_press_title', 'selines_news_title', 'selines_other_news_title'],
    populate: { seo: { populate: '*' } },
  }
  return (await client.get<{ data: { attributes: NewsPageBlockDto } }>(path, { params })).data.data.attributes
}
